import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const useAverageLotValueTrendingItems = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.AverageLotValueTrendingItems,
        AmplitudeVariants.AverageLotValueTrendingItems.Treatment
    );
